import ObjectModelBuilderModel from "../tracked/objectModelBuilderModel";
import {PermitteeType} from "~/enums/permitteeType";
import Guid from "../../helpers/guid";
import ObjectModelAction from "./objectModelAction";
import Vue from "vue";
import User from "~/models/user";
import ObjectModelEntry from "~/models/objectModelEntries/objectModelEntry";

export default abstract class ObjectModelActionPermittee extends ObjectModelBuilderModel {
  client_id: string = Guid.create();
  reference_id: string = null;
  reference_type: PermitteeType = PermitteeType.objectOwner;

  name?: string;
  first_name?: string;
  last_name?: string;
  _display: () => string = () => this.client_id;

  except = ['objectModel', 'createEmbeddedObject', 'first_name', 'last_name', 'name'];

  constructor(objectModelAction: ObjectModelAction, json: any = {}) {
    super();
    this.defineProperty('client_id', json['client_id'] || Guid.create());
    this.defineProperty('reference_id', json['reference_id'] || null);
    this.defineProperty('reference_type', json['reference_type'] || PermitteeType.objectOwner);
    this.setDefaultDisplay();
    this.loadFromJson(json, objectModelAction.rootModel);
    this.rootModel = objectModelAction.rootModel;
    this.parent = objectModelAction;
    this.setInDictionary();
  }

  setInDictionary() {
    Vue.set(this.parent[this.rootName], this.client_id, this);
  }

  abstract get rootName(): string;

  get display() {
    return this._display();
  }

  set display(funcOrString: Function | string) {
    if (typeof funcOrString === 'string') {
      this._display = () => funcOrString;
    } else {
      this._display = () => funcOrString(this);
    }
  }

  setDefaultDisplay() {
    switch (this.reference_type) {
      case PermitteeType.objectOwner:
        this.display = 'Record Holder';
        break;
      case PermitteeType.group: // intentional fallthrough
      case PermitteeType.relatedObjectOwner:
        // using String so undefined turns into "undefined"
        this.display = () => String(this.name);
        break;
      case PermitteeType.user:
        this.display = () => `${this.first_name} ${this.last_name}`;
        break;
    }
  }

  matches(user: User, entry: ObjectModelEntry): boolean {
    switch (this.reference_type) {
      case PermitteeType.objectOwner:
        return user.id === entry.owner.id;
      case PermitteeType.relatedObjectOwner:
        return entry.entryRelationsArray.some(er => er.relation.client_id === this.reference_id && er.relatedEntry.owner?.id === user.id) ||
          entry.inverseEntryRelationsArray.some(er => er.relation.client_id === this.reference_id && er.entry.owner?.id === user.id);
      case PermitteeType.user:
        return user.id === this.reference_id;
      case PermitteeType.group:
        return user.group_ids.includes(this.reference_id);
      default:
        return false;
    }
  }
}